<template>
  <div class="abstract-card">
    <div class="header">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractEvaluationSettings.guide')}} <el-switch v-model="form.evaluationSettings.enableGuideline"></el-switch></div>
      <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.guideMsg')}}</span>
    </div>
    <transition name="el-fade-in">
      <div class="mt-3" v-if="form.evaluationSettings.enableGuideline">
        <quill-editor :options="editorOption" ref="myQuillEditor" v-model="form.evaluationSettings.guideline" @ready="onEditorReady($event)" />
      </div>
    </transition>
    <div class="header mt-3">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractEvaluationSettings.scoreFormat')}}</div>
      <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.scoreFormatMsg')}}</span>
    </div>
    <el-row class="mt-3">
      <el-row :gutter="10" class="mb-2" v-for="item in getEnums.find((x) => x.title == 'EvaluationScoreFormat').enums" :key="item.key">
        <el-col :span="12">
          <el-radio v-model="form.evaluationSettings.scoreFormat" :label="item.key">{{ item.displayName }}</el-radio>
        </el-col>
        <el-col :span="12">
          <el-button-group v-if="item.key == 0">
            <el-button size="mini" round type="primary">{{$t('components.abstract.tabs.abstractEvaluationSettings.accepted')}}</el-button>
            <el-button size="mini" round type="default">{{$t('components.abstract.tabs.abstractEvaluationSettings.conditionallyAccepted')}}</el-button>
            <el-button size="mini" round type="default">{{$t('components.abstract.tabs.abstractEvaluationSettings.reject')}}</el-button>
          </el-button-group>
          <el-rate v-if="item.key == 1" :value="5" disabled></el-rate>
          <el-slider :min="1" :value="sliderRate" :max="100" v-if="item.key == 2"></el-slider>
        </el-col>
      </el-row>
    </el-row>
    <div class="mt-3">
      <QuestionLibrary :id="null" :type="3" />
    </div>

    <div class="header mt-4">
      <div class="title d-flex justify-content-between">{{$t('components.abstract.tabs.abstractEvaluationSettings.reviewSettings')}}</div>
      <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.reviewSettingsMsg')}}</span>
    </div>

    <el-row :gutter="10" class="mt-3">
      <el-col :span="24">
        <div class="custom-set-container" :class="form.evaluationSettings.enableBlindPeerReview ? 'sactive' : 'spassive'">
          <div class="custom-set-inner">
            <i class="fa" :class="form.evaluationSettings.enableBlindPeerReview ? 'fa-eye' : 'fa-eye-slash'"></i>
            <div class="custom-set-info">
              <label>
                {{$t('components.abstract.tabs.abstractEvaluationSettings.enablePeerReview')}}
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </label>
              <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.enablePeerReviewMsg')}}</span>
            </div>
          </div>
          <div class="custom-set-actions fend">
            <el-switch v-model="form.evaluationSettings.enableBlindPeerReview"></el-switch>
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="mt-2">
        <div class="custom-set-container" :class="form.evaluationSettings.showOthersReviewersScore ? 'sactive' : 'spassive'">
          <div class="custom-set-inner">
            <i class="fa" :class="form.evaluationSettings.showOthersReviewersScore ? 'fa-eye' : 'fa-eye-slash'"></i>
            <div class="custom-set-info">
              <label>
                {{$t('components.abstract.tabs.abstractEvaluationSettings.otherReviewersScore')}}
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </label>
              <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.otherReviewersScoreMsg')}}</span>
            </div>
          </div>
          <div class="custom-set-actions fend">
            <el-switch v-model="form.evaluationSettings.showOthersReviewersScore"></el-switch>
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="mt-2">
        <div class="custom-set-container" :class="form.evaluationSettings.sendReminderToReviewers ? 'sactive' : 'spassive'">
          <div class="custom-set-inner">
            <i class="fa" :class="form.evaluationSettings.sendReminderToReviewers ? 'fa-eye' : 'fa-eye-slash'"></i>
            <div class="custom-set-info">
              <label>
                {{$t('components.abstract.tabs.abstractEvaluationSettings.sendReminder')}}
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </label>
              <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.sendReminderMsg')}}</span>
            </div>
          </div>
          <div class="custom-set-actions fend">
            <el-switch v-model="form.evaluationSettings.sendReminderToReviewers"></el-switch>
          </div>
        </div>
      </el-col>
      <el-col :span="24" class="mt-2">
        <div class="custom-set-container" :class="form.evaluationSettings.lockAbstractEvaluationSystem ? 'sactive' : 'spassive'">
          <div class="custom-set-inner">
            <i class="fa" :class="form.evaluationSettings.lockAbstractEvaluationSystem ? 'fa-eye' : 'fa-eye-slash'"></i>
            <div class="custom-set-info">
              <label>
                {{$t('components.abstract.tabs.abstractEvaluationSettings.lockAbstract')}}
                <el-tooltip content="Content" placement="bottom">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </label>
              <span>{{$t('components.abstract.tabs.abstractEvaluationSettings.lockAbstractMsg')}}</span>
            </div>
          </div>
          <div class="custom-set-actions fend">
            <el-switch v-model="form.evaluationSettings.lockAbstractEvaluationSystem"></el-switch>
          </div>
        </div>
      </el-col>
    </el-row>
        <div class="bottom mt-3 d-flex justify-content-end">
      <el-button type="primary" size="mini" round :loading="loading" @click="saveAbstractEvaluationSettings">{{$t('components.abstract.tabs.abstractEvaluationSettings.save')}}</el-button>
    </div>
  </div>
</template>

<script>
import QuestionLibrary from '../../register-form/QuestionLibrary.vue';
import axios from 'axios';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  props: ['data'],
  components: { QuestionLibrary, quillEditor },
  data() {
    return {
      form: {},
      sliderRate: 50,
      loading: false,
      timeout: null,
      editorOption: {
        modules: {
          toolbar: {
            container: [['bold', 'italic', 'underline', 'strike'], [{ color: [] }, { background: [] }], ['clean'], ['link', 'image', 'video']],
            handlers: {
              image: () => {
                this.selectLocalImage();
              },
            },
          },

          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },

          resize: {
            modules: ['Resize'],
          },
        },
      },
    };
  },
  computed: {
    getEnums() {
      return this.$store.getters.getEnums;
    },
  },
  methods: {
    async saveAbstractEvaluationSettings() {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.loading = true;
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch('abstractUpdateEvaluationSettings', this.form);

        this.validationErrors = res.data.validationErrors;
        this.loading = false;
      }, 500);
    },
    onEditorReady(editor) {
      editor.root.setAttribute('data-placeholder', this.$t('enterText'));
      editor.getModule('toolbar').addHandler('image', () => {
        this.selectLocalImage(editor);
      });
    },
    selectLocalImage() {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file);
        } else {
          console.warn('You could only upload images.');
        }
      };
    },
    saveToServer(file) {
      const fd = new FormData();
      fd.append('image', file);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', axios.defaults.baseURL + 'event/uploadImage?uploadType=html&language=' + this.$i18n.locale, true);
      xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url);
          } else {
            this.$message.error(body.alert.message);
          }
        }
      };

      xhr.send(fd);
    },
    insertToEditor(url) {
      const range = this.$refs.myQuillEditor.quill.getSelection();
      this.$refs.myQuillEditor.quill.insertEmbed(range.index, 'image', `${url}`);
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  },
  watch: {
    data: function() {
      if (this.data != undefined && this.data != null) {
        this.form = this.data;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/AbstractEvaluationSettings.vue